import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";

import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import InputComponent from "../../components/InputComponent";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { CheckListModelTaskDTO } from "../../models/CheckListModelTask/CheckListModelTaskDTO";
import { CheckListModelTaskService } from "../../services/CheckListModelTaskService";

export default function CheckListModelTaskDetails() {
    const intl = useIntl();
    const { id } = useParams<{ id: string }>();
    const checkListModelTaskService = new CheckListModelTaskService();

    const [task, setTask] = useState<CheckListModelTaskDTO>({} as CheckListModelTaskDTO);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getTask = async () => {
        setIsLoading(true);
        const response = await checkListModelTaskService.GetById(Number(id));
        if (!response.success || !response.obj) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        setTask(response.obj);
        setIsLoading(false);
    };

    useEffect(() => {
        getTask();
    }, []);

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="col">
                        <PageTitle
                            title={intl.formatMessage({ id: 'Screens.CheckListModelTask.Details.Title' })}
                            allowGoBack={true}
                            dynamicTitle={() => `${intl.formatMessage({ id: 'Screens.CheckListModelTask.Details.Info.Title' })}  ${task?.title ?? ''}`}
                        />
                    </div>
                </div>

                <div className="pageBody">
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <Col xl={6} lg={12} md={12} sm={12} xs={12}>
                            <Row style={{ margin: 0, padding: 0 }}>
                                <InputComponent
                                    xl={12}
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type="text"
                                    value={task.title}
                                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Details.Title" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>
                            <Row style={{ margin: 0, padding: 0 }}>
                                <InputComponent
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type="number"
                                    value={task.order}
                                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Details.Order" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                                <InputComponent
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type="text"
                                    value={task.active ? intl.formatMessage({ id: "Screens.CheckListModelTask.Active" }) : intl.formatMessage({ id: "Screens.CheckListModelTask.Inactive" })}
                                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Details.Status" })}
                                    readOnly={true}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>
                            <Row style={{ margin: 0, padding: 0 }}>
                                <InputComponent
                                    xl={12}
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    type="textArea"
                                    value={task.description}
                                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Details.Description" })}
                                    readOnly={true}
                                    style={{ width: "100%", height: "120px" }}
                                    showLoadingSkeleton={isLoading}
                                />
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}
